import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Component that renders a link, also allows links to look like buttons.
 */
var LinkComponent = /** @class */ (function (_super) {
    __extends(LinkComponent, _super);
    function LinkComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LinkComponent.prototype.clicked = function (event) {
        if (!this.disabled) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LinkComponent.prototype, "button", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LinkComponent.prototype, "disabled", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], LinkComponent.prototype, "bold", void 0);
    __decorate([
        Prop({
            validator: function (value) {
                return (typeof value === 'number' ||
                    typeof value === 'string' ||
                    typeof value === 'object');
            },
        }),
        __metadata("design:type", Object)
    ], LinkComponent.prototype, "to", void 0);
    LinkComponent = __decorate([
        Component({
            name: 'ui-link',
        })
    ], LinkComponent);
    return LinkComponent;
}(Mixins(MagicConfigMixin)));

export default LinkComponent;
